import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_reaction-t",
  "use": "svg_reaction-t-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"svg_reaction-t\"><path d=\"M5.878.324A.5.5 0 0 1 6.346 0h.933a.5.5 0 0 1 .468.676l-5.625 15a.5.5 0 0 1-.468.324H.721a.5.5 0 0 1-.469-.676l5.625-15Z\" fill=\"currentColor\" /><path d=\"M8.122.324A.5.5 0 0 0 7.654 0H6.72a.5.5 0 0 0-.468.676l5.625 15a.5.5 0 0 0 .469.324h.931a.5.5 0 0 0 .469-.676l-5.625-15Z\" fill=\"currentColor\" /><path d=\"M3 9h8v2H3V9Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol